export default __webpack_public_path__ + "static/accurateTracking-c6252ee77042348587136f7d79e0db1b.png";